import once from 'lodash/once';
import querystring from 'querystring';
import { reportMeasureEntry } from '../../actions/performance';
import { isMonitoringEnabled } from '../../util/performance';
import context from '../../util/context';

const warnOnce = once(console.warn);

export default function createMonitor(store, cb = handlePerformanceEvent) {
  if (isMonitoringEnabled(store)) {
    const observer = new context.PerformanceObserver(cb(store.dispatch));
    observer.observe({ entryTypes: ['measure'] });
  } else {
    warnOnce(
      'Unable to monitor performance: The performance.measure method from the User Timing API is not available in this context.'
    );
  }
}

export function handlePerformanceEvent(dispatch) {
  return function handler(list) {
    for (const entry of list.getEntries()) {
      const measurement = performanceEntryToMeasurement(entry);
      if (shouldReportMeasurement(measurement)) {
        dispatch(reportMeasureEntry(measurement));
      }
    }
  };
}

function performanceEntryToMeasurement({
  duration,
  entryType,
  name,
  startTime
}) {
  return {
    ...querystring.parse(name),
    duration,
    entryType,
    name,
    startTime
  };
}

function shouldReportMeasurement({ action, component }) {
  return action === 'LoadSearchResults' || component === 'App';
}



// WEBPACK FOOTER //
// ./js/store/config/performance.js